import { render, staticRenderFns } from "./SoundSpace.vue?vue&type=template&id=2ceec37a"
import script from "./SoundSpace.vue?vue&type=script&lang=js"
export * from "./SoundSpace.vue?vue&type=script&lang=js"
import style0 from "./SoundSpace.vue?vue&type=style&index=0&id=2ceec37a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports